<app-page-header [heading]="'Purchase Return List'" [icon]="'fa-list-alt'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class="row">
    <div class="col-lg-8"></div>
    <div class="col-lg-4">
      <div class="input-group ">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="purchase.search_purchase" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Supplier Name/Invoice no/Invoice Date..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="purchase.search_purchase != ''" class="fa fa-close"></i>
            <i *ngIf="purchase.search_purchase == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <table class="table tbl table-hover table-striped table-bordered">
      <thead>
      <tr class="text-center  ">
        <th width="1%">Sl#</th>
        <th>Supplier Name</th>
        <th>Return Date</th>
        <th>Reference Number</th>
        <th>Total Amount</th>
        <th width="10%">View</th>
      </tr>
      <tr *ngIf="(purchase_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of purchase_data;let i=index" style="font-size: 12px">
        <td>{{ i + 1 }}</td>
        <td>{{ data.VENDOR_NAME }}</td>
        <td>{{ data.RETURN_DATE | date:'dd/MM/yyyy' }}</td>
        <td>{{ data.REFERENCE_NUMBER }}</td>
        <td class="text-right">{{ data.TOTAL_AMOUNT }}</td>
        <td>
          <button (click)="purached_items(data);open(content);" class="btn btn-sm btn-info" title="View"><i
            class="fa fa-eye"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="getPurchaseList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h3 class="modal-title" id="modal-basic-title">
        Return Particular List
      </h3>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel panel-default">
          <div class="panel-heading">


          </div>
        </div>
        <div *ngIf="purchased" class="row ml-3">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-4">
                <label>Vendor Name</label>
              </div>
              <div class="col-lg-8">
                :&nbsp;<span class="tle">{{ purchased.VENDOR_NAME }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-3">
                <label>Return Date</label>
              </div>
              <div class="col-lg-8">
                :&nbsp; <span class="tle">{{ purchased.RETURN_DATE | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-body">
          <table class="table tbl  table-bordered" style="background-color: #f3f8fd">
            <thead>
            <tr class="text-center">
              <th>Sl</th>
              <th width="25%">Particular</th>
              <th>Invoice No</th>
              <th>UOM</th>
              <th>Total Qty</th>
              <th>Unit Price</th>
              <th>Actual Price</th>
              <th>Return Reason</th>
              <th>Return Qty</th>
              <th>Amount</th>
              <th>Return Amount</th>
            </tr>

            </thead>
            <tbody>
            <tr *ngFor="let item of item_list;let i=index">
              <td class="text-center">{{ 1 + i }}</td>
              <td>{{ item.TRADE_NAME }}</td>
              <td>{{ purchased.INVOICE_NUMBER }}</td>
              <td>{{ item.UNIT_DESC }}</td>
              <td class="text-right">{{ item.QUANTITY }}</td>
              <td class="text-right">{{ item.UNIT_PRICE }}</td>
              <td class="text-right">{{ item.ACTUAL_AMOUNT }}</td>
              <td>{{ item.RETURN_REASON }}</td>
              <td class="text-right">{{ item.RETURN_QUANTITY }}</td>
              <td class="text-right">{{ item.GROSS_AMOUNT }}</td>
              <td class="text-right">{{ item.RETURN_AMOUNT }}</td>

            </tr>


            </tbody>
            <tfoot>
            <tr>
              <th class="text-right" colspan="9" style="font-size:15px">Total</th>
              <th class="text-right">{{ price_total | number : '1.2-2' }}</th>
              <th class="text-right">{{ total | number : '1.2-2' }}</th>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
